<template>
    <div class="card-general card-view mt10">
        <el-form
            :model="currentContact"
            label-position="top"
            ref="currentContact"
            v-loading="loading"
        >
            <el-row>
                <el-col :span="24" :class="{ 'error-input': errors.name }">
                    <el-form-item label="Контакт" prop="name">
                        <el-input v-model="currentContact.name" size="mini" />
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="error" v-if="errors.name">
                {{ errors.name[0] }}
            </div>
            <el-form-item label="Телефон" />
            <template v-for="(contactPhone, index) in currentContact.contact_phones">
                <el-row class="mt10" :key="index">
                    <el-col :span="12" :class="{ 'error-input': errors.phone }">
                        <div class="el-input el-input--mini">
                            <the-mask
                                v-model="contactPhone.phone"
                                mask="+# (###) ###-##-##"
                                placeholder="+7 (495) 123-45-67"
                                class="el-input__inner"
                            />
                        </div>
                    </el-col>
                    <el-col :span="2">
                        <div class="pt5 pl5 pointer" @click="calltoPhone(contactPhone.phone)">
                            <font-awesome-icon icon="phone" class="orange" title="Позвонить" />
                        </div>
                    </el-col>
                    <el-col :span="2" v-if="!isMain(contactPhone)">
                        <div class="delete-phone" @click="deletePhone(index, contactPhone)">
                            <i class="el-icon-close"></i>
                        </div>
                    </el-col>
                </el-row>
                <div class="error" v-if="errors[`contact_phones.${index}.phone`]" :key="index">
                    {{ errors[`contact_phones.${index}.phone`][0] }}
                </div>
            </template>
            <el-row>
                <el-col :span="24" class="mt10">
                    <el-button class="button-icon" size="mini" @click="addNewPhone">
                        <font-awesome-icon icon="plus" class="orange" />
                    </el-button>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" :class="{ 'error-input': errors.email }">
                    <el-form-item label="E-mail" prop="email" class="mt10">
                        <el-input v-model="currentContact.email" size="mini" @blur="contactFind('email')" />
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="error" v-if="errors.email">
                {{ errors.email[0] }}
            </div>
            <el-row v-if="showSaveBtn">
                <el-col :span="24" class="mt10">
                    <el-button class="spreadsheet-header-button" type="warning" size="mini" @click="saveContact">
                        Сохранить контакт
                    </el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus, faPhone } from '@fortawesome/free-solid-svg-icons';
import isEqual from 'lodash/isEqual';

library.add(faPlus);
library.add(faPhone);

const emptyContactPhones = [
    {
        id: null,
        contact_id: null,
        phone: null,
        is_main: null
    }
];

export default {
    name: 'Contact',
    data() {
        return {
            currentContact: {
                id: null,
                name: null,
                phone: null,
                email: null,
                contact_phones: [...emptyContactPhones]
            },
            loadedContact: {},
            loading: false,
            loaded: false,
            showSaveBtn: false,
            errors: {},
            lastSearchedPhone: null
        };
    },
    props: {
        contact: {
            type: Object,
            default: () => {}
        },
        isNew: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        currentContact: {
            handler(val, oldVal) {
                if (this.loaded) {
                    //хак т.к. на маске нельзя поймать событие blur
                    if (!this.currentContact.id &&
                        val.contact_phones[0] &&
                        val.contact_phones[0].phone &&
                        val.contact_phones[0].phone.length === 11) {
                        this.contactFind('phone');
                    }
                } else {
                    this.loaded = true;
                }
                this.showSaveBtn = !isEqual(val, this.loadedContact);
            },
            deep: true
        },
        contact(value) {
            if (value && value.name !== null) {
                this.processContactData(this.contact);
            }
        }
    },
    created() {
        if (this.isNew) {
            this.currentContact.contact_phones = [{
                id: null,
                contact_id: null,
                phone: null,
                is_main: null
            }];
        }
        this.processContactData(this.contact);
    },
    methods: {
        processContactData(contact) {
            if (!contact || Object.values(contact).every(field => field === null)) {
                return;
            }
            this.currentContact = {
                id: contact.id,
                name: contact.name,
                phone: contact.phone,
                email: contact.email,
                contact_phones: contact.contact_phones ? [...contact.contact_phones.map(phone => { return { ...phone }; })] : [...emptyContactPhones]
            };
            this.loadedContact = {
                id: contact.id,
                name: contact.name,
                phone: contact.phone,
                email: contact.email,
                contact_phones: contact.contact_phones ? [...contact.contact_phones.map(phone => { return { ...phone }; })] : [...emptyContactPhones]
            };
            this.$emit('update-contact', contact.id);
            this.$emit('update-contact-data', contact);
        },
        isMain(contactPhone) {
            return contactPhone.is_main === 1;
        },
        calltoPhone(phone) {
            this.loading = true;
            this.$store.dispatch('voip/callToPhone', { phone: phone }).then(
                response => {
                    console.log('response', response.data.data);
                    this.$message({
                        showClose: true,
                        message: 'Начат звонок на номер ' + phone,
                        type: 'success',
                        duration: 3000,
                        customClass: this.alertClass()
                    });
                    this.errors = {};
                },
                error => {
                    console.log('error', error.response.data);
                    this.$message({
                        showClose: true,
                        message: 'Ошибка при звоноке на номер ' + phone,
                        type: 'error',
                        duration: 1500,
                        customClass: this.alertClass()
                    });
                }
            ).finally(() => { this.loading = false; });
        },
        deletePhone(index) {
            const phones = [...this.currentContact.contact_phones];
            phones.splice(index, 1);
            this.currentContact.contact_phones = [...phones];
        },
        addNewPhone() {
            const phone = {
                id: null,
                contact_id: this.currentContact.id,
                phone: null,
                is_main: 0
            };
            this.currentContact.contact_phones = [...this.currentContact.contact_phones, ...[phone]];
        },
        contactFind(type) {
            if (!this.currentContact.id) {
                let value = null;
                if (type === 'phone' && this.currentContact.contact_phones[0] && Object.prototype.hasOwnProperty.call(this.currentContact.contact_phones[0], 'phone')) {
                    const phone = this.currentContact.contact_phones[0].phone;
                    if (this.lastSearchedPhone !== phone) {
                        value = phone;
                        this.lastSearchedPhone = phone;
                    }
                } else {
                    value = this.currentContact[type] ? this.currentContact[type] : null;
                }
                if (value && type) {
                    this.findContact({
                        field: type,
                        value
                    });
                }
            }
        },
        findContact(findData) {
            this.loading = true;
            this.$store.dispatch('contacts/find', findData).then(
                response => {
                    if (response.data.success) {
                        this.processContactData(response.data.data);
                    }
                }
            ).finally(() => { this.loading = false; });
        },
        saveContact() {
            this.loading = true;
            let requestUrl = 'updateContact';
            if (!this.currentContact.id) {
                requestUrl = 'createContact';
            }
            this.$store.dispatch('contacts/' + requestUrl, this.currentContact).then(
                response => {
                    this.$message({
                        showClose: true,
                        message: 'Контакт сохранен',
                        type: 'success',
                        duration: 5000,
                        customClass: this.alertClass()
                    });
                    this.showSaveBtn = false;
                    this.processContactData(response.data.data);
                    this.errors = {};
                },
                error => {
                    this.errors = error.response.data.errors;
                }
            ).finally(() => { this.loading = false; });
        }
    }
};
</script>
